var _path, _polygon, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisRetirerBap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8,16.2C5.2,16,5.7,15.8,6,15.4c1-1,1.2-2.6,0.4-3.8c-0.3-0.5-0.8-0.9-1.4-1c0.6-0.5,0.9-1.2,0.9-2c0-0.4-0.1-0.9-0.3-1.3 C5.5,7,5.2,6.6,4.9,6.4C4.6,6.1,4.2,5.9,3.8,5.8C3.3,5.7,2.7,5.6,2.1,5.6H0.5v10.7H3C3.6,16.4,4.2,16.3,4.8,16.2z M2.1,7.1h0.6 c0.5,0,0.9,0.1,1.3,0.4c0.3,0.3,0.5,0.7,0.4,1.2c0,0.4-0.1,0.9-0.4,1.2c-0.4,0.3-0.8,0.4-1.3,0.4H2.1V7.1z M2.1,11.6h0.8 c0.6-0.1,1.3,0.1,1.8,0.5c0.3,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2c-0.5,0.3-1,0.5-1.6,0.4h-1V11.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.1,8 11.1,5.5 9.7,6.3 12.2,8.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,9.4c-0.1,0-0.2,0-0.3,0c-0.9,0-1.7,0.3-2.3,1c-0.6,0.7-0.9,1.6-0.9,2.6c0,0.1,0,0.2,0,0.2L11.8,9.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,6.5c-0.3-0.3-0.8-0.6-1.2-0.7c-0.7-0.1-1.3-0.2-2-0.2h-0.1L22.5,2L21,0.7l-8.2,9l0,0l-1,1.1l0,0L9.9,13c0,0,0,0,0-0.1 l-1.4,1.5l0,0L1.7,22l1.4,1.3L9.7,16c1.2,0.9,2.9,0.7,3.9-0.3v0.7h1.6V10l2.3-2.5v8.9h1.6V12h0.8c1,0.1,1.9-0.3,2.7-0.9 c0.7-0.6,1-1.4,1-2.3C23.5,7.9,23.2,7.1,22.6,6.5z M13.2,14.6c-0.4,0.4-0.9,0.6-1.4,0.6c-0.4,0-0.7-0.1-1-0.3l2.7-2.9 c0.2,0.3,0.2,0.7,0.2,1.1C13.7,13.6,13.6,14.1,13.2,14.6z M19.7,10.5h-0.6V7.1h0.5c1.5,0,2.3,0.6,2.3,1.7S21.2,10.5,19.7,10.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisRetirerBap);
export default __webpack_public_path__ + "static/media/action_gris_retirer-bap.a15fd21b.svg";
export { ForwardRef as ReactComponent };